import { makeStyles } from '@material-ui/core/styles';

import { reskinStyles } from 'core/components/theme/theme-variant';

export default makeStyles((theme) => ({
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    columnGap: theme.spacing(4),
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(3),
    '& .MuiTabs-root': {
      marginBottom: 0,
      borderBottom: 0,
      minWidth: 280
    }
  },
  controls: {
    display: 'flex',
    gap: theme.spacing(2),
    marginLeft: 'auto',
    padding: theme.spacing(1, 0)
  },
  controlButton: {
    '&.Mui-disabled': {
      // The shared button theme forces disabled text to white with !important.
      color: `${theme.colorPalette.beige_90} !important`
    }
  },
  cardContent: {
    minWidth: 0,
    padding: theme.spacing(3, 5),
    minHeight: 64
  },
  cardContentRight: {
    position: 'static',
    flexShrink: 0,
    marginRight: theme.spacing(16)
  },
  cardButtons: {
    top: theme.spacing(2)
  },
  groupHeading: {
    minWidth: 0
  },
  groupTitle: {
    fontSize: 18,
    fontWeight: 600,
    overflowWrap: 'anywhere'
  },
  groupMetadata: {
    marginTop: theme.spacing(1),
    fontSize: 13,
    color: theme.colorPalette.beige_90
  },
  changeCount: {
    whiteSpace: 'nowrap',
    backgroundColor: theme.colorPalette.beige_40,
    color: theme.colorPalette.green_80,
    fontWeight: 500,
    ...reskinStyles(theme, theme.labelStyles.outlined)
  },
  computedSection: {
    padding: theme.spacing(3, 5, 2),
    fontSize: 16
  },
  group: {
    marginBottom: theme.spacing(3),
    '& table': {
      tableLayout: 'fixed'
    },
    '& thead tr': {
      height: 36
    },
    '& th, & td': {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1)
    }
  },
  fieldColumn: {
    width: '40%',
    paddingLeft: theme.spacing(5)
  },
  valueColumn: {
    width: '30%'
  },
  fieldCell: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(2)
  },
  fieldName: {
    overflowWrap: 'anywhere'
  },
  valueCell: {
    overflowWrap: 'anywhere'
  },
  beforeValue: {
    backgroundColor: theme.colorPalette.red_100_10
  },
  afterValue: {
    backgroundColor: theme.colorPalette.green_75_op_10
  },
  missingValue: {
    color: theme.colorPalette.beige_90,
    fontStyle: 'italic'
  },
  changeTag: {
    textTransform: 'uppercase'
  },
  added: {
    backgroundColor: theme.colorPalette.green_75_op_30
  },
  removed: {
    backgroundColor: theme.colorPalette.red_100_10
  }
}));
